import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, IntegerDecoder, MapDecoder, StringDecoder, field } from '@simonbackx/simple-encoding';
import { upgradePriceFrom2To4DecimalPlaces } from '../upgradePriceFrom2To4DecimalPlaces.js';
export class ChargeMembershipsTypeSummary extends AutoEncoder {
    memberships = 0;
    members = 0;
    price = 0;
    organizations = 0;
}
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsTypeSummary.prototype, "memberships", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsTypeSummary.prototype, "members", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], ChargeMembershipsTypeSummary.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsTypeSummary.prototype, "organizations", void 0);
export class ChargeMembershipsSummary extends AutoEncoder {
    running = false;
    memberships = 0;
    members = 0;
    price = 0;
    organizations = 0;
    membershipsPerType = new Map();
    trials = ChargeMembershipsTypeSummary.create({});
}
__decorate([
    field({ decoder: BooleanDecoder })
], ChargeMembershipsSummary.prototype, "running", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsSummary.prototype, "memberships", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsSummary.prototype, "members", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], ChargeMembershipsSummary.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsSummary.prototype, "organizations", void 0);
__decorate([
    field({ decoder: new MapDecoder(StringDecoder, ChargeMembershipsTypeSummary) })
], ChargeMembershipsSummary.prototype, "membershipsPerType", void 0);
__decorate([
    field({ decoder: ChargeMembershipsTypeSummary, version: 355 })
], ChargeMembershipsSummary.prototype, "trials", void 0);
//# sourceMappingURL=ChargeMembershipsSummary.js.map